import styled, { css } from 'styled-components';


export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    align-items: flex-end;
    background-color: ${theme.v2.colors.neutral.highLight};
    border-radius: 16px 16px 0px 0px;
    display: flex;
    display: flex;
    height: 148px;
    position: relative;
    width: 100%;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const BannerImage = styled.img`
    width: 100%;
`;

export const Image = styled.img`
    height: 77px;
    margin-left: 33px;
    width: 96px;
`;

export const SaluteMessage = styled.span`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px 16px 16px 4px;
    box-sizing: border-box;
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.medium};
    left: 122px;
    max-width: 192px;
    padding: 16px;
    position: absolute;
    top: 13px;
  `}
`;

export const RoundButton = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 100%;
    border: 0px;
    cursor: pointer;
    display: flex;
    height: 36px;
    justify-content: center;
    padding: 0px;
    position: absolute;
    right: 8px;
    top: 8px;
    width: 36px;
    z-index: 1;
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 0px 0px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 20px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      border-radius: 16px;
    }
  `}
`;

export const ContentTitle = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryMedium};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.bold};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 160px;
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ContentDescription = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowPure};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ActionsRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 56px;
`;
